import React, { useState, useMemo, useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import "./Diary.css";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import empty from "./pictures/icons8-torn-page-64.png";

import Switch from "@mui/material/Switch";

const label = { inputProps: { "aria-label": "Color switch demo" } };

function Diary() {
  const [checked, setChecked] = useState(true);
  const [client, setClient] = useState({
    clientName: "",
    bust: 0,
    waist: 0,
    hip: 0,
    frontWaistLength: 0,
    backWaistLength: 0,
    armLength: 0,
    thigh: 0,
    ankle: 0,
    inSeam: 0,
    outSeam: 0,
    crotchDepth: 0,
  });
  const [clientList, setClientList] = useState([]);
  function handleClientChange(e) {
    setClient({
      ...client,
      clientName: e.target.value,
    });
  }
  function handleBustChange(e) {
    setClient({
      ...client,
      bust: e.target.value,
    });
  }
  function handleWaistChange(e) {
    setClient({
      ...client,
      waist: e.target.value,
    });
  }
  function handleHipChange(e) {
    setClient({
      ...client,
      hip: e.target.value,
    });
  }
  function handleFrontWaistLength(e) {
    setClient({
      ...client,
      frontWaistLength: e.target.value,
    });
  }
  function handleBackWaistLength(e) {
    setClient({
      ...client,
      backWaistLength: e.target.value,
    });
  }
  function handleArmLength(e) {
    setClient({
      ...client,
      armLength: e.target.value,
    });
  }
  function handleThighChange(e) {
    setClient({
      ...client,
      thigh: e.target.value,
    });
  }
  function handleAnkleChange(e) {
    setClient({
      ...client,
      ankle: e.target.value,
    });
  }
  function handleInSeam(e) {
    setClient({
      ...client,
      inSeam: e.target.value,
    });
  }
  function handleOutSeam(e) {
    setClient({
      ...client,
      outSeam: e.target.value,
    });
  }
  function handleCrotchDepth(e) {
    setClient({
      ...client,
      crotchDepth: e.target.value,
    });
  }

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleSubmit = (e) => {
    if (localStorage.getItem("clients") === null) {
      localStorage.setItem("clients", JSON.stringify([client.clientName]));
      localStorage.setItem(client.clientName, JSON.stringify(client));
      alert("Client Details Have Been Saved");
      return;
    } else {
      localStorage.setItem(client.clientName, JSON.stringify(client));
      let formerClients = JSON.parse(localStorage.getItem("clients"));
      console.log(formerClients.length);
      formerClients.push(client.clientName);
      localStorage.setItem("clients", JSON.stringify(formerClients));
      alert("Client Details Have Been Saved");
    }
  };
  const nullCount = new Map(
    [...new Set(Object.values(client))].map((x) => [
      x,
      Object.values(client).filter((y) => y === x).length,
    ])
  );
  useEffect(() => {
    let clients = JSON.parse(localStorage.getItem("clients"));
    let client = [];
    if (clients !== null) {
      for (let i = 0; i < clients.length; i++) {
        client.push(JSON.parse(localStorage.getItem(clients[i])));
      }
    }

    setClientList(client);
  }, []);

  return (
    <div className="diary-container">
      <div className="diary-header">
        <Navigation></Navigation>
      </div>

      <div className="diary-content">
        {checked ? (
          <div>
            <div className="diary-content-label">
              <h2>
                Tailor Diary{" "}
                <Switch
                  checked={checked}
                  {...label}
                  onChange={handleChange}
                  defaultChecked
                  color="warning"
                  size="medium"
                />
              </h2>{" "}
            </div>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <p>Enter Client Details</p>
              <br></br>
              <small>All Units are in inches</small>
              <br></br>

              <div className="diary-content-form">
                <TextField
                  required
                  id="standard-required"
                  label="Client Name"
                  placeholder="Client Name"
                  variant="standard"
                  value={client.clientName}
                  onChange={handleClientChange}
                />
                <TextField
                  id="standard-number"
                  label="Bust"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  step={0.1}
                  value={client.bust}
                  onChange={handleBustChange}
                  placeholder="Bust"
                  variant="standard"
                />
                <TextField
                  id="standard-number"
                  label="Waist"
                  placeholder="Waist"
                  value={client.waist}
                  onChange={handleWaistChange}
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                />{" "}
                <TextField
                  id="standard-number"
                  label="Hip"
                  placeholder="Hip"
                  type="number"
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="standard"
                  value={client.hip}
                  onChange={handleHipChange}
                />{" "}
                <TextField
                  id="standard-number"
                  label="Front Waist Length"
                  placeholder="Front Waist Length"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.frontWaistLength}
                  onChange={handleFrontWaistLength}
                />{" "}
                <TextField
                  id="standard-number"
                  label="Back Waist Length"
                  placeholder="Back Waist Length"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  value={client.backWaistLength}
                  onChange={handleBackWaistLength}
                  variant="standard"
                />{" "}
                <TextField
                  id="standard-number"
                  label="Arm Length"
                  placeholder="Arm Length"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.armLength}
                  onChange={handleArmLength}
                />{" "}
                <TextField
                  id="standard-number"
                  label="Thigh"
                  placeholder="Thigh"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.thigh}
                  onChange={handleThighChange}
                />{" "}
                <TextField
                  id="standard-number"
                  label="Ankle"
                  placeholder="Ankle"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.ankle}
                  onChange={handleAnkleChange}
                />
                <TextField
                  id="standard-number"
                  label="Inseam"
                  placeholder="Inseam"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.inSeam}
                  onChange={handleInSeam}
                />
                <TextField
                  id="standard-number"
                  label="Outseam"
                  placeholder="Outseam"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  variant="standard"
                  value={client.outSeam}
                  onChange={handleOutSeam}
                />
                <TextField
                  id="standard-number"
                  label="Crotch Depth"
                  placeholder="Crotch Depth"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  value={client.crotchDepth}
                  onChange={handleCrotchDepth}
                  variant="standard"
                />
                <button
                  disabled={
                    nullCount.get(0) > 2 || client.clientName.length == 0
                  }
                  onClick={handleSubmit}
                  className="btn"
                >
                  Submit
                </button>
              </div>
            </Box>
          </div>
        ) : (
          <div>
            <div className="diary-content-label">
              <h2>
                Tailor Diary{" "}
                <Switch
                  checked={checked}
                  {...label}
                  onChange={handleChange}
                  defaultChecked
                  color="warning"
                  size="medium"
                />
              </h2>{" "}
            </div>
            <div className="diary-content-list">
              {clientList.length !== 0 ? (
                <div>
                  <ul>
                    {clientList.map((values, key) => {
                      return (
                        <li key={key} className="diary-content-list-item">
                          <Accordion
                            style={{
                              width: "75vw",
                              backgroundImage:
                                "linear-gradient(#f0592a, #ec216e)",
                              borderRadius: "1rem",
                              boxShadow: "6px 6px 3px  #808080 ",
                            }}
                          >
                            <AccordionSummary
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                              style={{
                                backgroundColor: "#333",
                                color: "white",
                              }}
                            >
                              <Typography
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                {`${values?.clientName}`}
                                <ExpandMoreIcon />
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                              style={{
                                marginTop: "-4rem",
                                marginBottom: "-4rem",
                                color: "#fff",
                              }}
                            >
                              <Typography
                                className="measurements"
                                style={{ fontSize: "0.8em" }}
                              >
                                Bust:{`${values?.bust}`}
                                <br></br>
                                Waist: {values?.waist}
                                <br></br>
                                Hip: {values?.hip}
                                <br></br>
                                Front Waist Length:{values?.frontWaistLength}
                                <br></br>
                                Back Waist Length: {
                                  values?.backWaistLength
                                }{" "}
                                <br></br>
                                Arm Length: {values?.armLength}
                                <br></br>
                                Thigh: {values?.thigh}
                                <br></br>
                                Ankle: {values?.ankle}
                                <br></br>
                                In Seam: {values?.inSeam}
                                <br></br>
                                Out Seam: {values?.outSeam}
                                <br></br>
                                Crotch Depth: {values?.crotchDepth}
                                <br></br>
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <br></br>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <div>
                  <h3>There are no client Details</h3>
                  <img className="empty" src={empty} alt="Empty Diary" />
                </div>
              )}
            </div>
          </div>
        )}{" "}
      </div>
      <div className="diary-footer">
        <Footer></Footer>
      </div>
      <style jsx>{`
        .btn {
          background: ${nullCount.get(0) > 2 || client.clientName.length == 0
            ? "#808080"
            : "linear-gradient(#f0592a, #ec216e)"};
        }
      `}</style>
    </div>
  );
}

export default Diary;
